<template>
  <section class="h_75">
    <m-img src="@/v2/mobile/assets/image/h_75.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
<style lang="less" scoped>
.h_75 {
  margin-top: -5px;
  margin-bottom: -5px;
  position: relative;
  z-index: 15;
}
</style>
